<div class="cabecera-modal">
  <strong>ADMINISTRAR CUOTAS INICIALES GESTOR DE PROYECTOS</strong>
  <mat-icon class="cerrar-modal posicion-cerrar" (click)="cerrar()">
    close
  </mat-icon>
</div>

<div class="content-modal">
  <form [formGroup]="formCuotas" (ngSubmit)="guardar()">
    <div
      [ngClass]="
        !mobileQuery.matches
          ? 'contenedor-formulario'
          : 'contenedor-formulario-movil'
      "
    >
      <div class="row">
        <div class="col-12 mb-4 text-secondary">
          <h4 class="text-center">Cuotas Gestor de Proyectos</h4>
        </div>

        <!-- Espacio Disponible -->
        <div class="col-md-6 col-12 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Espacio Disponible (MB)</mat-label>
            <input
              class="text-center"
              matInput
              type="number"
              step="0.01"
              formControlName="espacioDisponible"
              placeholder="Espacio Disponible en MB"
            />
            <mat-hint *ngIf="valorInicialEspacio">
              Valor original: {{ valorInicialEspacio }} MB
            </mat-hint>
            <mat-error
              *ngIf="formCuotas.get('espacioDisponible')?.hasError('required')"
            >
              El espacio disponible es requerido
            </mat-error>
            <mat-error
              *ngIf="formCuotas.get('espacioDisponible')?.hasError('min')"
            >
              El espacio debe ser mayor a 0
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Tiempo Disponible -->
        <div class="col-md-6 col-12 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tiempo Disponible (horas)</mat-label>
            <input
              class="text-center"
              matInput
              type="number"
              step="0.01"
              formControlName="tiempoDisponible"
              placeholder="Tiempo Disponible en horas"
            />
            <mat-hint *ngIf="valorInicialTiempo">
              <span>
                Horas y minutos:
                {{ mostrarValorEnHorasYMinutos() }}
              </span>
              <br />
              <span> Valor original: {{ valorInicialTiempo }} horas </span>
            </mat-hint>
            <mat-error
              *ngIf="formCuotas.get('tiempoDisponible')?.hasError('required')"
            >
              El tiempo disponible es requerido
            </mat-error>
            <mat-error
              *ngIf="formCuotas.get('tiempoDisponible')?.hasError('min')"
            >
              El tiempo debe ser mayor a 0
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Botones -->
        <div class="col-12 text-end mt-4">
          <button mat-button type="button" (click)="cerrar()">Cancelar</button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!formCuotas.valid"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
